/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/11/10
 * @updateTime 2021/11/10
 * @decription  复议中请求数据并组装页面所需数据
 * @namespace 【request】 请求组装
 */
import request from '@/api/axios';
import {
    typeDlrlx,
    typeFyAjlx,
    typeFysx,
    typeGzdwlx,
    typeMz,
    typeRylx,
    typeSfzjlx,
    typeSsdW,
    typeTjrlx,
    typeXb
} from "@/filters";
export default {
    // 方法
    methods: {
        /**
         * 获取基本数据信息项
         * @param {String} fyid 复议id
         * @param {String} bqid 保全id
         * @returns {Promise} promise对象
         * */
        requestBasic(fyid, bqid = ''){
            return new Promise((resolve, reject) => {
                request({
                    url: 'ssbq/api/fy/fysqinfo',
                    method: 'get',
                    params:{
                        time: new Date().getTime(),
                        // 复议id
                        fyid: fyid,
                        // 保全id
                        bqid: bqid
                    },
                }).then(res => {
                    // 表单数据
                    const _formData = {
                        ...res.data
                    }
                    // 如果申请日期不存在，则获取当前日期
                    if (!_formData.dtSqrq) {
                        _formData.dtSqrq = this.getCurrentData();
                    }
                    // 复议事项文本
                    _formData.nFysxText = typeFysx(_formData.nFysx);
                    // 案件类型文本
                    _formData.nAjlxText = typeFyAjlx(_formData.nAjlx);
                    // 统计人身份文本
                    _formData.cTjrlxText = typeTjrlx(_formData.cTjrlx);
                    resolve(_formData);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },

        /**
         * 获取申请人数据
         * @param {String} fyid 复议id
         * @param {String} bqid 保全id
         * @returns {Promise} promise对象
         * */
        requestSqrData(fyid, bqid = '') {
            return new Promise((resolve, reject) => {
                request({
                    url: 'ssbq/api/fy/fysqrsxq',
                    method: 'get',
                    params:{
                        time: new Date().getTime(),
                        // 复议id
                        fyid: fyid,
                        // 保全id
                        bqid: bqid
                    },
                }).then(res => {
                    const _sqrDataList = [];
                    // 循环遍历数据处理数据
                    res.data.forEach(item => {
                        // 申请人类型文本
                        item.cSqrlxText = typeRylx(item.cSqrlx);
                        // 诉讼地位
                        item.nSsdwText = typeSsdW(item.nSsdw);
                        // 证件类型
                        item.cZjlxText = typeSfzjlx(item.cZjlx);
                        // 单位性质
                        item.cDwxzText = typeGzdwlx(item.cDwxz);
                        // 性别
                        item.cSqrxbText = typeXb(item.cSqrxb);
                        // 民族
                        item.nMzText = typeMz(item.nMz);
                        _sqrDataList.push(item);
                    });
                    resolve(_sqrDataList);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },

        /**
         * 请求代理人数据
         * @param {String} fyid 复议id
         * @param {String} bqid 保全id
         * @returns {Promise} promise对象
         * */
        requestDlrData(fyid, bqid = '') {
            return new Promise((resolve, reject) => {
                request({
                    url: 'ssbq/api/fy/fydlrsxq',
                    method: 'get',
                    params:{
                        time: new Date().getTime(),
                        // 复议id
                        fyid: fyid,
                        // 保全id
                        bqid: bqid
                    },
                }).then(res => {
                    // 代理人数据列表
                    const _dlrDataList = [];
                    // 循环遍历数据处理数据
                    res.data.forEach(item => {
                        // 代理人类型文本
                        item.cDlrlxText = typeDlrlx(item.cDlrlx);
                        // 证件类型文本
                        item.cDlrzjlxText = typeSfzjlx(item.cDlrzjlx);
                        // 代理人性别
                        item.cDlrxbText = typeXb(item.cDlrxb);
                        _dlrDataList.push(item);
                    });
                    resolve(_dlrDataList);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },

        /**
         * 请求上传材料数据
         * @param {String} fyid 复议id
         * @returns {Promise} promise对象
         * */
        requestScclData(fyid) {
            return new Promise((resolve, reject) => {
                request({
                    url: 'ssbq/api/fy/fysccls',
                    method: 'get',
                    params:{
                        time: new Date().getTime(),
                        // 复议id
                        fyid: fyid
                    },
                }).then(res => {
                    resolve(res.data);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        }
    }
};
